module.exports = __webpack_public_path__ + "img/reprezentuok.0e636d5.svg";